import { render } from "./TabsCrm.vue?vue&type=template&id=2687baac"
import script from "./TabsCrm.vue?vue&type=script&lang=js"
export * from "./TabsCrm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__